import { Link } from "react-router-dom";
import type { Article } from "@/mocks/content";

type Props = {
  articles: Article[];
};

export default function HotSidebar({ articles }: Props) {
  return (
    <aside className="flex flex-col gap-5 lg:sticky lg:top-24">
      <div className="rounded-lg border border-background-200 bg-background-50">
        <div className="flex items-center gap-2 border-b border-background-200 px-4 py-3">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-700">
            <i className="ri-fire-line"></i>
          </span>
          <h3 className="font-heading text-base font-bold text-foreground-950">热门内容推荐</h3>
        </div>
        <div className="flex flex-col divide-y divide-background-200">
          {articles.map((item, i) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex cursor-pointer items-start gap-3 p-3 transition-colors hover:bg-background-100"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                  i < 3 ? "bg-accent-500 text-white" : "bg-background-200 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <div className="h-14 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={item.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0">
                <h4 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h4>
                <span className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  {(item.views / 1000).toFixed(1)}k
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-secondary-100 p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950">还没看够？</h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-700">
          从观影指南开始，快速找到最适合你的观看方式与延伸阅读。
        </p>
        <Link
          to="/guide"
          className="mt-4 inline-flex cursor-pointer items-center gap-2 rounded-md bg-primary-600 px-4 py-2 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-700"
        >
          <i className="ri-guide-line"></i>
          前往观影指南
        </Link>
      </div>
    </aside>
  );
}